import { Area } from '../types';
import { supabase } from '../lib/supabaseClient';

export const areaService = {
  /**
   * Obtiene la lista completa de áreas ordenada por fecha de creación.
   */
  async fetchAreas(): Promise<Area[]> {
    const { data, error } = await supabase
      .from('areas')
      .select('*')
      .order('created_at', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  /**
   * Agrega una nueva área de planta.
   */
  async addArea(area: Omit<Area, 'id'>): Promise<Area> {
    const { data, error } = await supabase
      .from('areas')
      .insert({
        name: area.name,
        description: area.description
      })
      .select()
      .single();

    if (error) {
      console.error('Error insertando área:', error);
      throw error;
    }
    return data;
  },

  /**
   * Actualiza los datos de un área.
   */
  async updateArea(area: Area): Promise<void> {
    const { error } = await supabase
      .from('areas')
      .update({
        name: area.name,
        description: area.description
      })
      .eq('id', area.id);

    if (error) throw error;
  },

  /**
   * Elimina un área por su ID.
   */
  async deleteArea(areaId: string): Promise<void> {
    const { error } = await supabase
      .from('areas')
      .delete()
      .eq('id', areaId);

    if (error) throw error;
  }
};
